import React, { useState } from "react";
import "./BeforeYouAsk.css";
import { Reserveseat } from "./Reserveseat";

import OverviewIcon from "../assets/images/overview-item-icon.png";

export const BeforeYouAsk = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsPlaying(true);
  };

  return (
    <div className="levelup-container">
      <div className="levelup-wrapper">
        {/* Header */}
        <div className="levelup-header">
          <h1 className="levelup-title">
            Are you ready to <span className="text-orange">level up</span>?
          </h1>
          <p className="levelup-subtitle">
            This program is a fit if you're looking to...
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="levelup-grid">
          {/* Left Column - Video Section */}
          <div className="video-section">
            <div className="video-wrapper" style={{ position: 'relative', width: '100%', height: '100%' }}>
              {!isPlaying ? (
 <div className="video-thumbnail-container" onClick={handlePlayVideo} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
  <img 
    src="https://img.youtube.com/vi/17YiMmhBgwc/maxresdefault.jpg" 
    alt="Video Thumbnail" 
    className="video-thumbnail"
  />
  <button className="play-button">
    <svg 
      className="play-icon" 
      fill="currentColor" 
      viewBox="0 0 24 24"
      width="40"
      height="40"
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  </button>
</div>
) : (
  <iframe
    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '12px' }}
    src="https://www.youtube.com/embed/17YiMmhBgwc?autoplay=1"
    title="Demo Video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
    className="video-iframe"
  ></iframe>
)}
            </div>
          </div>

          {/* Right Column - Two Cards */}
          <div className="cards-section">
            {/* This is for you if Card */}
            <div className="info-card card-for-you">
              <h3 className="card-header">This is for you if</h3>
              <ul className="card-list">
                <li className="card-item">
                  <span className="check-icon-orange"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>You Need Advanced Automation.</span>
                </li>
                <li className="card-item">
                  <span className="check-icon-orange"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>You Want Custom-Engineered Solutions.</span>
                </li>
                <li className="card-item">
                  <span className="check-icon-orange"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>You Value End-To-End Expertise.</span>
                </li>
                <li className="card-item">
                  <span className="check-icon-orange"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>You're A Leader In Manufacturing Or Logistics.</span>
                </li>
                <li className="card-item">
                  <span className="check-icon-orange"><img src={OverviewIcon} className="overview-item-icon" /></span>
                  <span>You're Seeking A Long-Term Strategic Partner.</span>
                </li>
              </ul>
            </div>

            {/* This is NOT for you if Card */}
            <div className="info-card card-not-for-you">
              <h3 className="card-header">This is NOT for you if</h3>
              <ul className="card-list">
                <li className="card-item">
                  <span className="cross-icon-red">❌</span>
                  <span>You Want Basic, Off-The-Shelf Products.</span>
                </li>
                <li className="card-item">
                  <span className="cross-icon-red">❌</span>
                  <span>You Prefer Theory Over Practical Solutions.</span>
                </li>
                <li className="card-item">
                  <span className="cross-icon-red">❌</span>
                  <span>You're Looking For Hobbyist-Level Projects.</span>
                </li>
                <li className="card-item">
                  <span className="cross-icon-red">❌</span>
                  <span>You Have No Specific Problem To Solve.</span>
                </li>
                <li className="card-item">
                  <span className="cross-icon-red">❌</span>
                  <span>You Prefer A Non-Collaborative Process.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};